import { groupBy } from 'lodash';

import ProductVariant from '@/shared/types/products/productVariant.type';

import useCustomsDetails from '../../../../components/CustomsDetails/hooks/useCustomsDetails';
import useAddFirstZone from '../components/AddFirstZone/hooks/useAddFirstZone';
import useProfileDetails from '../components/ProfileDetails/hooks/useProfileDetails';
import useSetupOptions from '../components/SetupOptions/hooks/useSetupOptions';

type Args = {
  setupOptionsState: ReturnType<typeof useSetupOptions>;
  profileDetailsState: ReturnType<typeof useProfileDetails>;
  addFirstZoneState: ReturnType<typeof useAddFirstZone>;
  customsDetailsState: ReturnType<typeof useCustomsDetails>;
  tableSelectedRows: ProductVariant[];
};

const getRequestBody = ({
  setupOptionsState,
  profileDetailsState,
  addFirstZoneState,
  customsDetailsState,
  tableSelectedRows,
}: Args) => {
  const { setupOptionsForm, setupOptionalStepsForm } = setupOptionsState;
  const { profileDetailsForm, packagingProperties } = profileDetailsState;
  const { addZoneForm } = addFirstZoneState;
  const { customsDetailsForm, brokerForm } = customsDetailsState;

  const customs_details = setupOptionalStepsForm.ignore_customs_details
    ? undefined
    : {
        ...customsDetailsForm,
        broker: brokerForm,
      };

  const profileDetails = {
    ...profileDetailsForm,
    payment_method_id: profileDetailsForm.payment_method_id || null,
  };

  const groups = groupBy(tableSelectedRows, (item) => item.product_id);

  const product_variants = Object.entries(groups).map(([key, value]) => ({
    product_id: key,
    variants: value.flatMap((item) => item.variant_id),
  }));

  return {
    profile: {
      ...setupOptionsForm,
      ...profileDetails,
      packaging_properties: { ...packagingProperties },
      customs_details,
      product_variants,
    },
    zone: {
      ...addZoneForm,
    },
  };
};

export default getRequestBody;
